export type Domain =
  | 'HEALTH'
  | 'ENVIRONMENT'
  | 'DEMOCRACY'
  | 'ADMINISTRATION'
  | 'EMPLOYMENT'
  | 'PROFESSION'
  | 'FAMILY'
  | 'EDUCATION'
  | 'TECHNIQUE'
  | 'SOCIAL'
  | 'SUSTAINABILITY'
  | 'HR'
  | 'IT'
  | 'CULTURE'
  | 'ECONOMY';

export const DomainLabels: { [x in Domain]: string } = {
  ADMINISTRATION: '総務・管理',
  EMPLOYMENT: '雇用・就労',
  SUSTAINABILITY: '持続可能性',
  DEMOCRACY: '議会・選挙',
  PROFESSION: '産業振興',
  FAMILY: '子ども・家庭',
  HR: '人事',
  IT: 'IT',
  CULTURE: '文化',
  ENVIRONMENT: '環境',
  SOCIAL: '福祉',
  HEALTH: '保健・医療',
  TECHNIQUE: '土木・建設',
  EDUCATION: '教育',
  ECONOMY: '財政'
};

export const DomainKeys: { [x in Domain]: x } = {
  ADMINISTRATION: 'ADMINISTRATION',
  EMPLOYMENT: 'EMPLOYMENT',
  SUSTAINABILITY: 'SUSTAINABILITY',
  DEMOCRACY: 'DEMOCRACY',
  PROFESSION: 'PROFESSION',
  FAMILY: 'FAMILY',
  HR: 'HR',
  IT: 'IT',
  CULTURE: 'CULTURE',
  ENVIRONMENT: 'ENVIRONMENT',
  SOCIAL: 'SOCIAL',
  HEALTH: 'HEALTH',
  TECHNIQUE: 'TECHNIQUE',
  EDUCATION: 'EDUCATION',
  ECONOMY: 'ECONOMY'
};
